import React from "react";
import yup from "yup";
import fetch from "isomorphic-unfetch";
import Reaptcha from "reaptcha";
import { Formik, Field, Form } from "formik";
import { INVESTOR_CONNECT_LEAD_CAPTURE_WEBHOOK } from "../constants/zapier";
import { SITE_KEY } from "../constants/recaptcha";
import Button from "./common/Button";
import SendIcon from "./icons/SendIcon";
import {
  Container,
  Label,
  Error,
  RecaptchaWrapper,
  ConfirmationMessage,
  ConfirmationIconLayout
} from "../styled/IBuyerConnectLeadCapture";

export default class IBuyerConnectLeadCapture extends React.Component {
  state = { submitted: false };

  validationSchema = yup.object().shape({
    name: yup.string().required(),
    email: yup
      .string()
      .email()
      .required(),
    phone: yup.string(),
    company: yup.string().required(),
    captcha: yup
      .mixed()
      .oneOf([true])
      .required()
  });

  render() {
    return (
      <Container>
        {this.state.submitted ? (
          <ConfirmationMessage status="success">
            <ConfirmationIconLayout>
              <SendIcon />
            </ConfirmationIconLayout>
            <p>Request received!</p>
            <p>We'll be in touch.</p>
          </ConfirmationMessage>
        ) : (
          <Formik
            onSubmit={this.handleSubmit}
            validationSchema={this.validationSchema}
            initialValues={{
              name: "",
              email: "",
              company: "",
              phone: "",
              captcha: false
            }}>
            {({ isValid, isSubmitting, errors, touched, setFieldValue }) => (
              <Form>
                <Label>
                  Name
                  {errors.name && touched.name && <Error>Required</Error>}
                  <Field name="name" placeholder="Full Name" />
                </Label>
                <Label>
                  Email
                  {errors.email && touched.email && <Error>Required</Error>}
                  <Field
                    type="email"
                    name="email"
                    placeholder="you@example.com"
                  />
                </Label>
                <Label>
                  Company
                  {errors.company && touched.company && <Error>Required</Error>}
                  <Field name="company" placeholder="" />
                </Label>
                <Label>
                  Phone number
                  <Field name="phone" placeholder="000-000-0000" />
                </Label>
                <RecaptchaWrapper>
                  <Reaptcha
                    ref={(e) => (this.captcha = e)}
                    sitekey={SITE_KEY}
                    onVerify={() => setFieldValue("captcha", true)}
                    onExpire={() => setFieldValue("captcha", false)}
                    onError={this.handleCaptchaError}
                  />
                </RecaptchaWrapper>
                <Button disabled={isSubmitting || !isValid}>
                  {isSubmitting ? "Sending Request..." : "Request Info"}
                </Button>
              </Form>
            )}
          </Formik>
        )}
      </Container>
    );
  }

  handleCaptchaError = (error) => {
    console.error("captcha error:", error);
  };

  handleSubmit = async (values, { resetForm }) => {
    const response = await fetch(INVESTOR_CONNECT_LEAD_CAPTURE_WEBHOOK, {
      method: "POST",
      body: JSON.stringify(values)
    });

    if (response.status === 200) {
      this.setState({ submitted: true });
      this.captcha.reset();
      resetForm();
    }
  };
}
